import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "./auth.service";

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return from(authService.isAuthenticated()).pipe(
    map((authenticated) => {
      if (authenticated) return true;
      return router.createUrlTree(["/login"]);
    }),
  );
};
